import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as RSFActions from './rsf.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class RSFStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new RSFActions.RSFRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.RSF, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new RSFActions.RSFCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new RSFActions.RSFUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new RSFActions.RSFDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new RSFActions.RSFRefresh());
          break;

        case SignalRAction.RequestRefresh:
          this.store.dispatch(new RSFActions.RSFRefreshById(data.id));
          break;
      }
    });
  }
}
